import * as Yup from "yup";

export const loginSchema = Yup.object({
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),

  password: Yup.string().required("Password is required"),
});

export const registerSchema = Yup.object({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  date_of_birth: Yup.date().required("Date of birth is required"),
  email: Yup.string().email("Enter valid email").required("Email is required"),
  phone: Yup.string()
    .matches(/^\d{10}$/, "Enter valid 10-digit mobile number")
    .required("Phone number is required"),
  gender: Yup.string().required("Gender is required"),
  marital_status: Yup.string().nullable(),

  address: Yup.object().shape({
    line1: Yup.string().required("Address is required"),
    line2: Yup.string().nullable(),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    zip: Yup.string()
      .matches(/^\d{5}$/, "Zip must be 5 digits")
      .required("Zip code is required"),
    country: Yup.string().required("Country is required"),
  }),

  password: Yup.string()
    .min(8, "Minimum 8 characters")
    .required("Password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
  terms: Yup.boolean()
    .oneOf([true], "You must accept the Terms and Privacy Policy")
    .required("You must accept the Terms and Privacy Policy"),
});

export const rsvpSchema = Yup.object({
  event: Yup.string().required("Please select an event"),
  full_name: Yup.string().required("Full name is required"),
  email: Yup.string().email("Enter valid email").required("Email is required"),
  phone: Yup.string()
    .matches(/^\d{10}$/, "Enter valid 10-digit mobile number")
    .required("Phone number is required"),
  number_of_guests: Yup.number().min(0, "Number of guests cannot be negative"),
});

export const memberSchema = Yup.object({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  date_of_birth: Yup.date().required("Date of birth is required"),
  gender: Yup.string().required("Gender is required"),
  marital_status: Yup.string().nullable(),
  relationship_id: Yup.string().required("Relationship is required"),
});

export const editProfileSchema = Yup.object({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
  date_of_birth: Yup.date().required("Date of birth is required"),
  gender: Yup.string().required("Gender is required"),
  marital_status: Yup.string().nullable(),
  // email: Yup.string().email("Enter valid email").required("Email is required"),
});

export const editMobileSchema = Yup.object({
  phone: Yup.string()
    .matches(/^\d{10}$/, "Enter valid 10-digit mobile number")
    .required("Phone number is required"),
});

export const verifyOtpAndResetSchema = Yup.object({
  otp: Yup.string()
    .matches(/^\d{6}$/, "OTP must be 6 digits")
    .required("OTP is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("New password is required"),

  confirmPwd: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords do not match")
    .required("Confirm password is required"),
});

export const changePasswordSchema = Yup.object({
  old_password: Yup.string().required("Old Password is required"),

  new_password: Yup.string()
    .min(8, "Minimum 8 characters")
    .required("New Password is required"),

  confirm_password: Yup.string()
    .oneOf([Yup.ref("new_password"), null], "Passwords do not match")
    .required("Confirm Password is required"),
});

export const contactUsSchema = Yup.object({
  full_name: Yup.string()
    .required("Full name is required"),

  email: Yup.string()
    .email("Enter valid email")
    .notRequired(), // optional

  phone: Yup.string()
    .matches(/^\d{10}$/, "Enter valid 10-digit mobile number")
    .required("Phone number is required"),

  message: Yup.string()
    .min(10, "Message must be at least 10 characters long")
    .required("Message is required"),
});
